/**
 * @file routes/pageLoader.ts
 * @description lazy loading of pages.
 *
 * @author ogarcia (ozkary)
 *
 */

/**
 * Use this loader to load dynamic/lazy container. it has retry logic to handling the missing chunk errors
 * @param page func with container to load
 * @param reLoad number of retries
 * @returns a page container
 */
const pageLoader = <T>(page: () => Promise<T>, reLoad = 3): Promise<T> => {
  return new Promise((resolve, reject) => {
    page()
      .then(resolve)
      .catch((error) => {
        if (reLoad === 0) {
          reject(error);
          // this is probably a white page error. load the help page
          window.location.replace('/end');
          return;
        }

        pageLoader(page, --reLoad).then(resolve, reject);
      });
  });
};

export default pageLoader;
